type ShippingScreenViewEventArgs = {
  screen: string
  checkoutId: string
}

type ShippingScreenViewEventExtra = {
  screen: string
  checkout_id: string
}

export const shippingScreenViewEvent = (args: ShippingScreenViewEventArgs) => {
  const extra: ShippingScreenViewEventExtra = {
    screen: args.screen,
    checkout_id: args.checkoutId,
  }

  return { event: 'shipping_options.screen', extra }
}

// Source: https://github.com/vinted/dwh-schema-registry/blob/bd07d3e78b3951daa9328387bfb31631397574ae/avro/events/shipping_options/map_preselection.avdl#L26
type ShippingMapPreselectionEventTarget = 'pickup_point_map'

type ShippingMapPreselectionEventArgs = {
  checkoutId: string
  target: ShippingMapPreselectionEventTarget
  info?: string
  infoPii?: string
}

type ShippingMapPreselectionEventExtra = {
  checkout_id: string
  target: ShippingMapPreselectionEventTarget
  info?: string
  info_pii?: string
}

export const shippingMapPreselectionEvent = (args: ShippingMapPreselectionEventArgs) => {
  const { checkoutId, target, info, infoPii } = args

  const extra: ShippingMapPreselectionEventExtra = {
    checkout_id: checkoutId,
    target,
    info,
    info_pii: infoPii,
  }

  return { event: 'shipping_options.map_preselection', extra }
}

// Source: https://github.com/vinted/dwh-schema-registry/blob/bd07d3e78b3951daa9328387bfb31631397574ae/avro/events/shipping_options/click.avdl#L26
type ShippingClickEventTarget =
  | 'pickup_point'
  | 'search_this_area'
  | 'current_location'
  | 'choose_pickup_point'
  | 'shipping_option'

type ShippingClickEventArgs = {
  screen: string
  checkoutId: string
  target: ShippingClickEventTarget
  valid?: boolean
  info?: string
  infoPii?: string
}

type ShippingClickEventExtra = {
  screen: string
  checkout_id: string
  target: ShippingClickEventTarget
  valid?: boolean
  info?: string
  info_pii?: string
}

export const shippingClickEvent = (args: ShippingClickEventArgs) => {
  const { screen, checkoutId, valid, target, info, infoPii } = args

  const extra: ShippingClickEventExtra = {
    screen,
    checkout_id: checkoutId,
    valid,
    target,
    info,
    info_pii: infoPii,
  }

  return { event: 'shipping_options.click', extra }
}

type ShippingShownPricesEventArgs = {
  itemId?: string
  orderId?: string
  checkoutId?: string
  itemPagePrice?: string
  homeDeliveryOptionPrice?: string
  pudoDeliveryOptionPrice?: string
  preselectPrice?: string
  checkoutSummaryShippingPrice?: string
}

type ShippingShownPricesEventExtra = {
  item_id?: string
  order_id?: string
  checkout_id?: string
  item_page_price?: string
  home_delivery_option_price?: string
  pudo_delivery_option_price?: string
  preselect_price?: string
  checkout_summary_shipping_price?: string
}

// TODO: temporary event, delete after DSA confirmation
export const shippingShownPricesEvent = (args: ShippingShownPricesEventArgs) => {
  const {
    itemId,
    orderId,
    checkoutId,
    itemPagePrice,
    homeDeliveryOptionPrice,
    pudoDeliveryOptionPrice,
    preselectPrice,
    checkoutSummaryShippingPrice,
  } = args

  const extra: ShippingShownPricesEventExtra = {
    item_id: itemId,
    order_id: orderId,
    checkout_id: checkoutId,
    item_page_price: itemPagePrice,
    home_delivery_option_price: homeDeliveryOptionPrice,
    pudo_delivery_option_price: pudoDeliveryOptionPrice,
    preselect_price: preselectPrice,
    checkout_summary_shipping_price: checkoutSummaryShippingPrice,
  }

  return { event: 'shipping.shown_prices', extra }
}

type ShippingPointPricesViewEventArgs = {
  checkoutId: string
  orderId: string
  loadedPudoMapPointsPrices?: Array<string>
}

type ShippingPointPricesViewEventExtra = {
  checkout_id: string
  order_id: string
  loaded_pudo_map_points_prices?: Array<string>
}

// TODO: temporary event, delete after DSA confirmation
export const shippingPointPricesEvent = (args: ShippingPointPricesViewEventArgs) => {
  const { checkoutId, orderId, loadedPudoMapPointsPrices } = args

  const extra: ShippingPointPricesViewEventExtra = {
    checkout_id: checkoutId,
    order_id: orderId,
    loaded_pudo_map_points_prices: loadedPudoMapPointsPrices,
  }

  return { event: 'shipping.points_prices', extra }
}
